import angular from 'angular';
import { defaults } from '../../defaults';
import { Log } from '../../log';
import TooltipExtension from './TooltipExtension';
const log = Log.channel('DialPadController');
class DialPadController {
    constructor($scope, $state, $timeout, $ionicPopover, ionicMaterialInk, CallsService, KayleeService, RoomService, $ionicViewSwitcher, $window, gettextCatalog, SelectMenuPositionService, $q, $ionicScrollDelegate, $document) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$ionicPopover = $ionicPopover;
        this.ionicMaterialInk = ionicMaterialInk;
        this.CallsService = CallsService;
        this.KayleeService = KayleeService;
        this.RoomService = RoomService;
        this.$ionicViewSwitcher = $ionicViewSwitcher;
        this.$window = $window;
        this.gettextCatalog = gettextCatalog;
        this.SelectMenuPositionService = SelectMenuPositionService;
        this.$q = $q;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.$document = $document;
        this.hasKeyboard = angular.isDefined(this.$window.cordova) &&
            angular.isDefined(this.$window.cordova.plugins) &&
            angular.isDefined(this.$window.cordova.plugins.Keyboard);
        this.room = null;
        this.site = null;
        this.videoCallTypeList = [
            { callType: 'video', label: this.gettextCatalog.getString('Video') },
            { callType: 'zoom', label: this.gettextCatalog.getString('Zoom') },
            { callType: 'googleMeet', label: this.gettextCatalog.getString('Google Meet') },
            { callType: 'teams', label: this.gettextCatalog.getString('Teams') },
        ];
        this.videoCallTypeMenu = null;
        this.videoCallTypeMenuPromise = null;
        this.dialString = '';
        this.displayDialString = '';
        this.hasOnlyPstn = false;
        this.hasUrlDialing = false;
        this.selectedCallType = {
            audio: 'voip',
            video: 'video',
        };
        this.selectedCallTypeDefaultInitialized = false;
        this.showDialStringInput = false;
        this.showDialStringStatic = true;
        this.canCallClass = this.CallsService.canCallClass;
        this.createCallTypeMenu = (callClass) => {
            if (callClass === 'video') {
                if (this.videoCallTypeMenuPromise === null) {
                    this.videoCallTypeMenuPromise = this.$ionicPopover
                        .fromTemplateUrl('dialPadCallTypeMenu.html', {
                        scope: this.$scope,
                        // HACK/undocumented: positionView overrides an internal
                        // positioning function, due to being combined via an internal
                        // .extend()
                        positionView: this.SelectMenuPositionService.createPositionViewHandler('#dummy-call-type-item', this.getCallTypeList('video').length),
                    })
                        .then(popover => {
                        this.videoCallTypeMenu = popover;
                        return this.$q.resolve(this.videoCallTypeMenu);
                    });
                }
                return this.videoCallTypeMenuPromise;
            }
            throw new Error('invalid call class: ' + callClass);
        };
        this.dial = (value) => {
            this.dialString += value;
        };
        this.dialBackspace = () => {
            this.dialString = this.dialString.slice(0, -1);
        };
        this.enterUrl = () => {
            const focusDialerInput = () => {
                const el = this.$window.document.querySelector('#dialer-input');
                if (!el)
                    return;
                const input = angular.element(el);
                if (input.length > 0) {
                    input[0].focus();
                }
            };
            // TODO: search for cordova plugin references in other code - mostly keyboard
            if ((this.hasKeyboard && this.$window.cordova.plugins.Keyboard.isVisible) ||
                !this.hasUrlDialing) {
                return;
            }
            if (!this.hasKeyboard) {
                // toggle URL dialing state, rather than letting keyboard hide toggle it
                this.showDialStringStatic = !this.showDialStringStatic;
                this.showDialStringInput = !this.showDialStringInput;
                if (this.showDialStringInput) {
                    this.$timeout(focusDialerInput, 100);
                }
                return;
            }
            this.showDialStringStatic = false;
            this.$timeout(() => {
                this.showDialStringInput = true;
                this.$timeout(focusDialerInput, 1);
            }, 100);
        };
        this.getCallTypeLabel = (callClass, callType) => {
            if (callClass === 'video') {
                var item = this.videoCallTypeList.find(function (callTypeItem) {
                    return callTypeItem.callType === callType;
                });
                if (item)
                    return item.label;
                return '';
            }
            throw new Error('invalid call class: ' + callClass);
        };
        this.getCallTypeList = (callClass) => {
            if (callClass === 'video') {
                return this.videoCallTypeList.filter((callTypeItem) => {
                    return this.CallsService.hasConfiguredCallCapsType(callTypeItem.callType);
                });
            }
            throw new Error('invalid call class: ' + callClass);
        };
        this.getNumConfiguredCallTypesForClass = (callClass) => {
            return this.CallsService.getNumConfiguredCallTypesForClass(callClass);
        };
        this.getPlaceCallLabel = (callClass) => {
            switch (callClass) {
                case 'audio':
                    /// Button label to place an audio (phone) call
                    return this.gettextCatalog.getString('Dial Phone');
                case 'video':
                    if (this.CallsService.getNumConfiguredCallTypesForClass('video') > 1) {
                        switch (this.selectedCallType.video) {
                            case 'googleMeet':
                            case 'teams':
                            case 'zoom':
                                return this.gettextCatalog.getString('Join {{networkName}}', {
                                    networkName: this.getCallTypeLabel('video', this.selectedCallType.video),
                                });
                            default:
                                /// Button label to place a video call
                                return this.gettextCatalog.getString('Dial Video');
                        }
                    }
                    if (this.CallsService.hasConfiguredCallCapsType('zoom')) {
                        /// Button label to join a Zoom meeting
                        return this.gettextCatalog.getString('Join Zoom');
                    }
                    /// Button label to place a video call
                    return this.gettextCatalog.getString('Dial Video');
                default:
                    return '';
            }
        };
        this.hasConfiguredCallCapsClass = this.CallsService.hasConfiguredCallCapsClass;
        this.hideKeyboard = () => {
            this.showDialStringInput = false;
            this.$timeout(() => {
                this.showDialStringStatic = true;
            }, 100);
        };
        this.hidePopovers = () => {
            if (this.videoCallTypeMenuPromise !== null) {
                this.videoCallTypeMenuPromise.then(function (menu) {
                    if (menu.isShown())
                        menu.hide();
                });
            }
        };
        this.initializeSelectedCallType = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            for (const callType of (_d = (_c = (_b = (_a = this.site) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.defaultCallTypes) === null || _c === void 0 ? void 0 : _c.video) !== null && _d !== void 0 ? _d : ['video']) {
                if (((_h = (_g = (_f = (_e = this.room) === null || _e === void 0 ? void 0 : _e.caps) === null || _f === void 0 ? void 0 : _f.maxCalls) === null || _g === void 0 ? void 0 : _g[callType]) !== null && _h !== void 0 ? _h : 0) > 0) {
                    this.selectedCallType.video = callType;
                    this.selectedCallTypeDefaultInitialized = true;
                    break;
                }
            }
        };
        this.keyboardHideHandler = (event) => {
            this.hideKeyboard();
        };
        this.onSelectCallType = (callType, $event) => {
            var callClass = this.activeCallTypeMenuCallClass;
            var promise = this.videoCallTypeMenu !== null ? this.videoCallTypeMenu.hide() : this.$q.resolve();
            promise.then(() => {
                if (this.room === null || !this.RoomService.online() || !callClass)
                    return;
                this.selectedCallType[callClass] = callType;
                this.selectedCallTypeDefaultInitialized = true;
            });
        };
        this.onShowCallTypeMenu = (callClass, $event) => {
            this.activeCallTypeMenuCallClass = callClass;
            return this.createCallTypeMenu(callClass).then((menu) => {
                return menu.show($event).then(this.scrollToSelected);
            });
        };
        this.onRoomServiceOnlineChanged = (online) => {
            var _a, _b, _c;
            if (online) {
                this.room = this.RoomService.getRoom();
                (_a = this.room) === null || _a === void 0 ? void 0 : _a.$onChange(this.onRoomChanged);
                if ((_b = this.room) === null || _b === void 0 ? void 0 : _b.siteId) {
                    this.site = this.KayleeService.getSite((_c = this.room) === null || _c === void 0 ? void 0 : _c.siteId);
                    this.site.$onChange(this.onSiteChanged);
                }
            }
            else {
                if (this.room !== null) {
                    this.room.$offChange(this.onRoomChanged);
                    this.room = null;
                }
                if (this.site !== null) {
                    this.site.$offChange(this.onSiteChanged);
                    this.site = null;
                }
            }
        };
        this.onRoomChanged = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
            if (!this.RoomService.online() || this.room === null)
                return;
            this.hasUrlDialing =
                ((_d = (_c = (_b = (_a = this.room) === null || _a === void 0 ? void 0 : _a.configuredCaps) === null || _b === void 0 ? void 0 : _b.maxCalls) === null || _c === void 0 ? void 0 : _c.voip) !== null && _d !== void 0 ? _d : 0) > 0 ||
                    ((_h = (_g = (_f = (_e = this.room) === null || _e === void 0 ? void 0 : _e.configuredCaps) === null || _f === void 0 ? void 0 : _f.maxCalls) === null || _g === void 0 ? void 0 : _g.video) !== null && _h !== void 0 ? _h : 0) > 0;
            this.hasOnlyPstn =
                ((_m = (_l = (_k = (_j = this.room) === null || _j === void 0 ? void 0 : _j.configuredCaps) === null || _k === void 0 ? void 0 : _k.maxCalls) === null || _l === void 0 ? void 0 : _l.pstn) !== null && _m !== void 0 ? _m : 0) > 0 &&
                    Object.keys((_q = (_p = (_o = this.room) === null || _o === void 0 ? void 0 : _o.configuredCaps) === null || _p === void 0 ? void 0 : _p.maxCalls) !== null && _q !== void 0 ? _q : {}).reduce((acc, curr) => {
                        var _a, _b, _c, _d;
                        return curr !== 'pstn'
                            ? acc
                            : acc + ((_d = (_c = (_b = (_a = this.room) === null || _a === void 0 ? void 0 : _a.configuredCaps) === null || _b === void 0 ? void 0 : _b.maxCalls) === null || _c === void 0 ? void 0 : _c[curr]) !== null && _d !== void 0 ? _d : 0);
                    }, 0) === 0;
            if (((_u = (_t = (_s = (_r = this.room) === null || _r === void 0 ? void 0 : _r.configuredCaps) === null || _s === void 0 ? void 0 : _s.maxCalls) === null || _t === void 0 ? void 0 : _t[this.selectedCallType.video]) !== null && _u !== void 0 ? _u : 0) <= 0) {
                this.initializeSelectedCallType();
            }
        };
        this.onSiteChanged = () => {
            if (!this.RoomService.online() || this.site === null)
                return;
            if (!this.selectedCallTypeDefaultInitialized) {
                this.initializeSelectedCallType();
            }
        };
        this.onStateChange = (event, toState, toParams, fromState, fromParams) => {
            var _a;
            if (toState.name !== 'control.dialpad') {
                (_a = this.tooltip) === null || _a === void 0 ? void 0 : _a.hide();
                this.hideKeyboard();
            }
            else {
                this.initializeSelectedCallType();
            }
        };
        this.placeCallByClass = (callClass, $event) => {
            if (!angular.isDefined(callClass)) {
                // No type passed in, so this could be the enter button on the
                // soft keyboard.  Try dialing whatever type of call is possible,
                // starting with video, then audio;
                if (this.CallsService.canCallClass('video')) {
                    callClass = 'video';
                }
                else {
                    callClass = 'audio';
                }
            }
            // Find the best available call type for the call class. (Assume
            // KayleeService.callTypes are in order from best to worst.)
            let foundCallType = null;
            if (callClass === 'video' &&
                this.CallsService.getNumConfiguredCallTypesForClass('video') > 1) {
                // If we dialing video and we are showing the call type selection for video,
                // then we will try to dial a call of the selected type.
                if (this.CallsService.canCallType(this.selectedCallType.video)) {
                    foundCallType = this.selectedCallType.video;
                }
                else {
                    // If no $event is passed in, the tooltip appears top center of
                    // the screen.
                    //
                    // Set a longer timer if the dial pad is in URI dialing mode
                    // so that the tooltip will appear over the correct button
                    // position when the dial pad flips back to digit dialing.
                    this.$timeout(() => {
                        var _a;
                        (_a = this.tooltip) === null || _a === void 0 ? void 0 : _a.show(this.CallsService.getExceededMaxCallsStringByType(this.selectedCallType.video), $event);
                    }, this.showDialStringStatic ? 1 : 300);
                    return;
                }
            }
            else {
                // Otherwise, try to find the best available call type.
                for (let callType of this.KayleeService.callTypes) {
                    if (this.KayleeService.getCallClass(callType) === callClass &&
                        this.CallsService.canCallType(callType)) {
                        foundCallType = callType;
                        break;
                    }
                }
                if (foundCallType === null) {
                    // If no $event is passed in, the tooltip appears top center of
                    // the screen.
                    //
                    // Set a longer timer if the dial pad is in URI dialing mode
                    // so that the tooltip will appear over the correct button
                    // position when the dial pad flips back to digit dialing.
                    this.$timeout(() => {
                        var _a;
                        if (callClass) {
                            (_a = this.tooltip) === null || _a === void 0 ? void 0 : _a.show(this.CallsService.getExceededMaxCallsStringByClass(callClass), $event);
                        }
                    }, this.showDialStringStatic ? 1 : 300);
                    return;
                }
            }
            if (this.dialString.length > 0) {
                this.$ionicViewSwitcher.nextDirection('forward');
                this.CallsService.placeCallByType({
                    callType: foundCallType,
                    dialString: this.dialString,
                });
                this.dialString = '';
                this.displayDialString = '';
            }
            if (this.hasKeyboard) {
                this.$window.cordova.plugins.Keyboard.close();
            }
        };
        this.scrollToSelected = () => {
            if (this.videoCallTypeMenu === null) {
                return;
            }
            const item = this.activeCallTypeMenuCallClass !== undefined
                ? this.videoCallTypeMenu.modalEl.querySelector('#' + this.selectedCallType[this.activeCallTypeMenuCallClass])
                : null;
            if (!item)
                return;
            if (item.offsetTop < this.videoCallTypeMenu.modalEl.scrollTop) {
                this.$ionicScrollDelegate
                    .$getByHandle('dialpad-call-type-scroll')
                    .scrollTo(0, item.offsetTop, true);
            }
            else if (item.offsetTop + item.offsetHeight >
                this.videoCallTypeMenu.modalEl.clientHeight) {
                this.$ionicScrollDelegate
                    .$getByHandle('dialpad-call-type-scroll')
                    .scrollTo(0, item.offsetTop +
                    item.offsetHeight -
                    this.videoCallTypeMenu.modalEl.clientHeight, true);
            }
        };
        this.showBackspace = () => {
            return this.dialString.length > 0;
        };
        $scope.vm = this;
        log.info('initializing');
        angular.extend(this, new TooltipExtension($scope, $ionicPopover));
        ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });
        $scope.$on('$destroy', () => {
            if (this.room !== null) {
                this.room.$offChange(this.onRoomChanged);
                this.room = null;
            }
            if (this.videoCallTypeMenuPromise !== null) {
                this.videoCallTypeMenuPromise.then((menu) => {
                    menu.remove();
                });
            }
            if (this.hasKeyboard) {
                $window.removeEventListener('native.keyboardhide', this.keyboardHideHandler);
            }
            RoomService.offOnlineChanged(this.onRoomServiceOnlineChanged);
        });
        $scope.$on('$stateChangeSuccess', this.onStateChange);
        $scope.$on('IdleTimeout', () => {
            this.hidePopovers();
        });
        $scope.$on('popover.removed', ($event, popover) => {
            if (popover === this.videoCallTypeMenu) {
                this.videoCallTypeMenu = null;
                this.videoCallTypeMenuPromise = null;
            }
        });
        $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
            if (toState.name !== 'control.dialpad')
                this.hidePopovers();
        });
        RoomService.onOnlineChanged(this.onRoomServiceOnlineChanged);
        if (this.hasKeyboard) {
            this.$window.addEventListener('native.keyboardhide', this.keyboardHideHandler);
        }
    }
}
DialPadController.$inject = [
    '$scope',
    '$state',
    '$timeout',
    '$ionicPopover',
    'ionicMaterialInk',
    'CallsService',
    'KayleeService',
    'RoomService',
    '$ionicViewSwitcher',
    '$window',
    'gettextCatalog',
    'SelectMenuPositionService',
    '$q',
    '$ionicScrollDelegate',
    '$document',
];
angular
    .module('inara')
    .directive('removeNgEmailValidation', () => {
    // Disable the built-in Angular e-mail validation if added to an input
    // element
    return {
        restrict: 'A',
        require: 'ngModel',
        link: (scope, element, attrs, ngModel) => {
            if (ngModel) {
                ngModel.$validators.email = () => true;
            }
        },
    };
})
    .directive('autoShrinkFont', () => {
    // Calculate the scroll width and shrink the font if scrolling would occur
    // by adding a shrink-font CSS class.
    return {
        restrict: 'A',
        link: (scope, element, attributes) => {
            scope.$watch(() => {
                return {
                    willScroll: element.prop('scrollWidth') > element.parent().prop('clientWidth'),
                    fieldLength: element.text().length,
                };
            }, (newValue, oldValue) => {
                if (newValue.willScroll && !element.hasClass('shrink-font')) {
                    element.addClass('shrink-font');
                }
                else if (newValue.fieldLength < oldValue.fieldLength &&
                    element.hasClass('shrink-font')) {
                    element.removeClass('shrink-font');
                }
            }, true);
        },
    };
})
    .controller('DialPadController', DialPadController);
export default DialPadController;
